export const custom = {
  /**
  * Idiomas disponibles ['es','en','pt','cat']
  */
  availableLangs: ['es'],

  /**
   * Idioma por defecto: ['es']
   */
  defaultLang: 'es',

  /**
   * Versión de la API: v2|v3
   */
  apiVersion: 'v3',

  /**
   * API key de conexión a la api definida en cada entorno
   * (debe ser el mismo en todos los servicios)
   */
  apiKey: '912c5790-2a0d-4b15-8e39-aa9dccb902f1',

  /**
   * Extensión en producción de URL de la app
   * (es, com, org...)
   */
   appUrlTld: 'com',

  /**
   * URL de la app
   *
   * subdominio.dominio
   */
  appUrlDomain: 'experienciaselect.vivofacil',

  /**
  * Nombre de la app
  */
  appName: 'Experiencia Select',

  /**
   * Nombre de marca interno (Alares, Vivofácil...)
   */
   brandName: 'Vivofácil',

  /**
   * Mail transport (alares, vivofacil...)
   */
   mailTransport: 'vivofacil',

  /**
  * Código de analytics 'G-XXXXXXXXXXX'
  * (Activado en pro, desactivado en pre y local)
  */
  analyticsId: 'G-KFPVM3DFN7',

  /** true o false. Define si es necesario hacer login para acceder a los contenidos */
  protected: true,

  /** Registro habilitado o deshabilitado */
  registration: true,

  /** true o false. Define si los formularios son para conciliación o no */
  conciliation: false,

  /** numero de telefono o false. Si es false no se muestra el icono de whatsapp en las páginas */
  whatsapp: false,

  /** true of false. Define si se muestra el botón para volver al inicio */
  homeButton: true,

  allowInsecurePasswords: false,

  /** true o false. Define si se muestra el area privada */
  showPrivateArea: true,

  /**
   * Api Key de Google Maps
   * Valores: false|<clave_publica>
   */
  googleMapsApiKey: 'AIzaSyAnoowlhGOt23DWy0YI7j5R7tbBCrCqYs0',

  /** true o false. Define si se activa DragonPass */
  dragonpassEnabled: true,

  /**
   * Datos eSIM para descontar stock
   *    min: número de días mínimo del rango
   *    max: número de días máximo del rango
   *    value: stock a descontar
   */
  esimRanges: [
    {min: 1, max: 7, value: 1},
    {min: 8, max: 14, value: 2},
    {min: 15, max: 21, value: 3},
    {min: 22, max: 28, value: 4}
  ],

  documentTypes: [1, 3],
  validateDocumentType: true,

  defaultCountryCode: 'ES',
  defaultCountryName: 'España',

  additionalRegisterFields: {
    telephone: {
      required: true
    },
    zipCode: {
      required: true
    },
    gender: {
      required: true
    },
    birthDate: {
      required: true
    }
  },

  registerByToken: true,
  allowRegisterByUser: true,
  showPublicContactChannels: false,
  showPrivateBannerContactChannels: false,
  contactFormPublicUuid: 'dc7b24e5-9658-444b-9aea-b56e837db1ef',
  //transferProvider: 'uber',

  /**
   * Habilitar validador de fecha límite
   */
  hasCutOffDateValidator: true,
  
  authStrategy: 'santander_select.strategy',

  /** testamentis */
  testamentisHereditary: 'https://formularios.alares.local/form/create/1edaeaf3-6bc3-651c-ae2c-1b9a90d4d278/embed',
  testamentisLiving: 'https://formularios.alares.local/form/create/1ed08dea-bf79-6442-8808-436f6414e40d/embed'
};

